// Função para colocar em uppercase a lista, aceitando 'name' caso não tenha 'label'
export const toUpperCaseList = (list: { label?: string; name?: string }[]): { label: string }[] => {
  if (list) {
    return list.map((item) => ({
      ...item,
      label: (item.label || item.name || '').toUpperCase(),
    }))
  }
  return []
}

// Função para ordenar alfabeticamente a lista, aceitando 'name' caso não tenha 'label'
export const sortAlphabetically = (list: { label?: string; name?: string }[]): { label: string }[] => {
  if (list) {
    return list
      .map((item) => ({
        ...item,
        label: item.label || item.name || '',
      }))
      .sort((a, b) => a.label.localeCompare(b.label))
  }
  return []
}

// Função para verificar se um valor está vazio
export const isEmpty = (value: any): boolean => {
  if (value === null || value === undefined) {
    return true
  }

  if (typeof value === 'string' && value.trim().length === 0) {
    return true
  }

  if (typeof value === 'number' && value === 0) {
    return true
  }

  if (Array.isArray(value) && value.length === 0) {
    return true
  }

  if (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0) {
    return true
  }

  return false
}
